// extracted by mini-css-extract-plugin
export default {"main":"StyleTime_main__dH5zj","heading":"StyleTime_heading__BOTjb","about":"StyleTime_about__bs62W","container":"StyleTime_container__M+Yeo"};